import { defineMessages } from "react-intl";

export const globalObjectSearchMessages = defineMessages({
  searchIn: {
    defaultMessage: "Search in",
    id: "object-selection-grid-messages.search-in",
  },
  find: {
    defaultMessage: "Find",
    id: "object-selection-grid-messages.find",
  },
  tip: {
    defaultMessage: "Enter one or more names or e-mail addresses separated by a ;",
    id: "object-selection-grid-messages.tip",
  },
  noObjectsFound: {
    defaultMessage: "No objects were found for one or more search strings.",
    id: "object-selection-grid-messages.no-objects-found",
  },
  multipleNamesFound: {
    defaultMessage: "Multiple Names Found",
    id: "object-selection-grid-messages.multiple-names-found",
  },
  moreThanOneObjectMatched: {
    defaultMessage:
      'More than one object matched the name "{searchString}". Select one or more names from the list, or, reenter the name.',
    id: "object-selection-grid-messages.more-than-one-object-matched",
  },
  matchingNames: {
    defaultMessage: "Matching names",
    id: "object-selection-grid-messages.matching-names",
  },
  skipThisObject: {
    defaultMessage: "Skip this object",
    id: "object-selection-grid-messages.skip-this-object",
  },
  top10MatchesShown: {
    defaultMessage:
      "Top 10 matches shown. To view additional matches, go back and click Select object(s).",
    id: "object-selection-grid-messages.top10-matches-shown",
  },
});
